// pages/mobile/appBadge.js
// The number on the Home Screen icon: messages still waiting for an answer.
// Supported on iPhone Home Screen apps and desktop Chrome/Edge; Android Chrome
// has no number badge and shows its own notification dot instead.
export const showOutstandingCount = (count) => {
  try {
    if (count > 0 && navigator.setAppBadge) return navigator.setAppBadge(count).catch(() => {});
    if (count === 0 && navigator.clearAppBadge) return navigator.clearAppBadge().catch(() => {});
  } catch (error) {
    // A browser that refuses badges just shows none.
  }
  return undefined;
};
